module.exports = __webpack_public_path__ + "static/media/calls.f2135af1.png";